import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import toast from 'react-hot-toast';

import store, { resetStore } from '../redux/store';
import { ACCOUNT, SIGNIN } from '../routes/routeConstants';
import { REFRESH_TOKEN_URL, refreshAccessToken } from '../services/authTokenService';

type ErrorRequestConfig = InternalAxiosRequestConfig & {
  skipLogoutRedirect?: boolean;
  _retry?: boolean;
};

const forceLogout = () => {
  toast.error('Session has expired');
  store.dispatch(resetStore());
  localStorage.removeItem('authData');
  window.location.href = `/${ACCOUNT}/${SIGNIN}`;
};

const errorInterceptor = () =>
  axios.interceptors.response.use(
    (response) => response,
    async (err: AxiosError) => {
      const requestConfig = err.config as ErrorRequestConfig | undefined;
      const isRefreshCall = requestConfig?.url?.includes(REFRESH_TOKEN_URL);

      if (err.response?.status !== 401 || requestConfig?.skipLogoutRedirect) {
        return Promise.reject(err);
      }

      if (window.location.href.includes('account')) {
        return Promise.reject(err);
      }

      // The refresh call itself failing (expired/revoked refresh token), or
      // an already-retried request failing again, means the session is over.
      if (isRefreshCall || requestConfig?._retry || !requestConfig) {
        forceLogout();
        return Promise.reject(err);
      }

      try {
        const newAccessToken = await refreshAccessToken();
        requestConfig._retry = true;
        requestConfig.headers.Authorization = `Bearer ${newAccessToken}`;
        return axios(requestConfig);
      } catch {
        forceLogout();
        return Promise.reject(err);
      }
    }
  );

export default errorInterceptor;
